import React from "react"
import Layout from "@components/Layout/hoc/withDatoData"
import Helmet from "@components/Helmet"
import DatoContent from "@dato/DatoContent"
import { renderMetaTags } from "react-datocms"

const Page: any = ({ data, module = "automotive" }) => {
  console.log("data", data)
  return (
    <Layout module={module}>
      <Helmet
        title={data?.page?.title || "TMI Products"}
        meta={renderMetaTags(data?.page?._seoMetaTags)}
        module={module}
      />
      {data?.page?.content && <DatoContent content={data.page.content} />}
    </Layout>
  )
}

const Thankyou: any = ({ data, module = "automotive" }) => {
  return (
    <Layout module={module}>
      <Helmet
        title={data?.page?.title || "TMI Products"}
        meta={renderMetaTags(data?.page?._seoMetaTags)}
        module={module}
      />
      {data?.page?.content && <DatoContent content={data.page.content} />}
    </Layout>
  )
}

export default Page
